import { Route } from '@angular/router';
import { RenderEngineComponent } from '@app/pages/render-engine/render-engine.component';

export const USER_ROUTES: Route[] = [
  {
    path: 'account',
    component: RenderEngineComponent,
    children: [
      {
        path: 'edit',
        component: RenderEngineComponent,
      },
    ],
  },  
  {
    path: 'orders',
    component: RenderEngineComponent,
    children: [
      {
        path: 'return/:orderId',
        component: RenderEngineComponent,
      },
    ],
    
  },
  {
    path: 'orders',
    component: RenderEngineComponent,
    children: [
      {
        path: 'rating/:orderId',
        component: RenderEngineComponent,
      },
    ],
    
  },
  {
    path: 'return-success',
    component: RenderEngineComponent,
  },
  {
    path: 'bank-accounts',
    component: RenderEngineComponent,
    children: [
      {
        path: 'new',
        component: RenderEngineComponent,
      },
    ],
  },
  {
    path: 'addressbook',
    component: RenderEngineComponent,
    children: [
      {
        path: 'new/:addressType',
        component: RenderEngineComponent,
      },
      {
        path: 'edit/:addressId',
        component: RenderEngineComponent,
      },
    ],
  },
  {
    path: 'password',
    component: RenderEngineComponent,
  },
  {
    path: 'login',
    component: RenderEngineComponent,
    children: [
      {
        path: 'verify',
        component: RenderEngineComponent,
      },
    ],
  },
  {
    path: 'forgot-password',
    component: RenderEngineComponent,
  },
  {
    path: 'reset-password',
    component: RenderEngineComponent,
  },
  {
    path: 'register',
    component: RenderEngineComponent,
    children: [
      {
        path: 'verify',
        component: RenderEngineComponent,
      },
      {
        path: 'thank-you',
        component: RenderEngineComponent,
      }
    ],
  },
  {
    path: 'business/register',
    component: RenderEngineComponent,
  },
  {
    path: 'assisted-sales',
    component: RenderEngineComponent,
  },
  {
    path: 'my-price-product',
    component: RenderEngineComponent,
  },
  {
    path: 'verification',
    component: RenderEngineComponent,
  },
  {
    path: 'request-for-quotes',
    component: RenderEngineComponent,
  },
  {
    path: 'invoices',
    component: RenderEngineComponent,
  },
  {
    path: 'invoices/verify',
    component: RenderEngineComponent,
  },
  {
    path: 'review/verify',
    component: RenderEngineComponent,
  },
  {
    path: 'invoice/status/:id',
    component: RenderEngineComponent,
  },
  {
    path: 'invoice/all-dues/:id',
    component: RenderEngineComponent,
  },
  {
    path: 'write-review',
    component: RenderEngineComponent,
  },
  {
    path: 'write-review/:sku',
    component: RenderEngineComponent,
  },
  {
    path: 'grievance-redressal',
    component: RenderEngineComponent,
  }
];
